import React, { useState, useEffect } from "react";
import Input from '../components/Input'
import { Link } from 'react-router-dom'
import Button from '../components/Button'
import AccountLayout from '../layouts/AccountLayout'
import Alert from '../components/Alert'
import { useHistory } from "react-router-dom";
import { Redirect } from 'react-router-dom';
import useFormValidation from "../libs/validation/formvalidation";
import authenticator from "../services/authenticateService";
import { usePost } from "../libs/service/api";
import ValidateAuth from "../libs/validation/register-validation";
import cookie from "../libs/cookie/client";

const Register = props => {
    const { toast, snackbar } = require('tailwind-toast')
    const history = useHistory();
    const [isSending, setIsSending] = useState(true)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [registerError, setRegisterError] = useState("")
    // const onLoginRedirectUrl = '/dashboard';
    const INITIAL_STATE = {
        emailid: "",
        mobileno: "",
        name: "",
        password: ""
    };
    const OnSuccess = () => {
        setIsSending(true)

        usePost('/commonapi/adduser',
            [{
                key: "emailid",
                value: values.emailid
            },
            {
                key: "mobileno",
                value: values.mobileno
            }, {
                key: "name",
                value: values.name
            }, {
                key: "password",
                value: values.password
            }, {
                key: "organization",
                value: ''
            }]
        ).then(res => {
            setIsSending(false);
            if (!res.ErrorState) {
                setRegisterError("")
                res.email = res.Data.Table[0].EmailID
                res.userid = res.Data.Table[0].userid
                res.username = res.Data.Table[0].Name
                res.needsassesmentid = 0
                res.authorizationKey = res.Data.Table[0].token
                //authenticator.login(res);
                cookie.setItem('authorizationKey', res.authorizationKey);
                cookie.setItem('username', res.username);
                cookie.setItem('email', res.email);
                cookie.setItem('userid', res.userid);
                cookie.setItem('needsassesmentid', 0);
                cookie.setItem('passwordexist', 1);
                
                toast().success('', 'You have created account sucessfully').with({
                    shape: 'square',
                    duration: 2000,
                    speed: 200,
                    positionX: 'center',
                    positionY: 'top',
                    color: 'text-white bg-primary border-primary-dark border rounded-lg',
                    fontColor: 'white',
                    fontTone: 0
                }).show()
                history.push(`/`)
            } else {
                setRegisterError(res.data)
            }
            console.log(res)
        });

    }

    const {
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        errors,
        isSubmitting
    } = useFormValidation(INITIAL_STATE, ValidateAuth, OnSuccess);

    const isDisable = () => {
        return isSubmitting || isSending;
    }

    useEffect(() => {
        if (authenticator.isLoggedIn()) {
            history.push('/dashboard')
        }
        setIsLoggedIn(authenticator.isLoggedIn())
        setIsSending(false)
    }, []);

    return (
        <AccountLayout showWelcome>
            {registerError &&
                <Alert type="secondary" heading="Create password mismatch" content={registerError} isVisible={true} />
            }
            {/* {errors && <div>
                <Alert type="secondary" heading="Create password mismatch" content={errors.emailid ? errors.emailid : ''} isVisible={true} />
            </div>}
            {errors && <div>
                <Alert type="secondary" heading="Create password mismatch" content={errors.mobileno ? errors.mobileno : ''} isVisible={true} />
            </div>}
            {errors && <div>
                <Alert type="secondary" heading="Create password mismatch" content={errors.name ? errors.name : ''} isVisible={true} />
            </div>}
            {errors && <div>
                <Alert type="secondary" heading="Create password mismatch" content={errors.password ? errors.password : ''} isVisible={true} />
            </div>} */}
            <div className="mb-4">Create account</div>
            <form className="account-form" onSubmit={handleSubmit}>
                <div className="mb-4">
                    <Input label="E-mail" type="email" placeholder="E-mail"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="emailid"
                        autoComplete="off"
                        defaultValue={values.emailid}
                        error={errors.emailid}
                        haserror={errors.emailid ? 1 : 0}
                    />
                </div>
                <div className="mb-4">
                    <Input label="Mobile No" type="number" placeholder="Mobile No"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.mobileno}
                        maxLength="10"
                        autoComplete="off"
                        name="mobileno"
                        error={errors.mobileno}
                        haserror={errors.mobileno ? 1 : 0}
                    />
                </div>
                <div className="mb-4">
                    <Input label="Name" type="text" placeholder="Name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.name}
                        name="name"
                        error={errors.name}
                        haserror={errors.name ? 1 : 0}
                    />
                </div>
                <div className="mb-4">
                    <Input label="Password" type="password" placeholder="*******"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.password}
                        name="password"
                        error={errors.password}
                        haserror={errors.password ? 1 : 0}
                    />
                </div>
                <div className=" mt-10" role="group">
                    {!isSending && (
                        <button type="submit" onClick={props.onClick} className="bg-primary hover:bg-primary-dark border-primary text-white font-semibold  text-base py-1.5 px-8 rounded-full inline-block border-2  active:border-3 disabled:opacity-50 focus:outline-none w-full mb-4">
                            Register
                        </button>
                    )}
                    {isSending && (

                        <div className="col-3  flex justify-center item-center aheight items-center border-primary text-white font-semibold  text-base  rounded-full  border-2  active:border-3 disabled:opacity-50 focus:outline-none w-full mb-4 " >
                            <div className="snippet py-1.5 px-8" data-title=".dot-pulse">
                                <div className="stage">
                                    <div className="dot-pulse"></div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex justify-center border-t border-primary-light pt-4 mt-5">
                    <Link to="/login/" className="text-primary font-semibold">Go to log in</Link>
                </div>
            </form>
        </AccountLayout>
    )
}

export default Register
